"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const react_select_1 = __importStar(require("react-select"));
const constants_1 = require("@/constants");
const __1 = require("..");
const styles_1 = __importStar(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const CheckboxControl = (props) => {
    const { value, isSelected, label, onChange } = props;
    const { Option } = react_select_1.components;
    return (core_1.jsx(Option, Object.assign({}, props, { className: styles_scss_1.default.multiSelectOption }),
        core_1.jsx("div", { className: styles_scss_1.default.multiSelectCheckbox },
            core_1.jsx(__1.Checkbox, { id: value, value: isSelected, checked: isSelected, ariaLabel: value, name: value, onChange: onChange, label: label }))));
};
const CustomMultiValueRemove = (_a) => {
    var props = __rest(_a, []);
    const { MultiValueRemove } = react_select_1.components;
    return (core_1.jsx(MultiValueRemove, Object.assign({}, props),
        core_1.jsx("img", { src: constants_1.Images.blueClose, alt: constants_1.Images.blueClose })));
};
const Dropdown = ({ error, testId, ariaLabel, className, disabled, label, multiselect, name, onBlur, onChange, options, placeholder, selectStyles, selectTheme, value, defaultValue, hideLabel, }) => {
    const specialProps = {
        components: { MultiValueRemove: CustomMultiValueRemove },
    };
    if (multiselect) {
        specialProps.components = Object.assign(Object.assign({}, specialProps.components), { Option: CheckboxControl });
        specialProps.closeMenuOnSelect = false;
        specialProps.hideSelectedOptions = false;
    }
    return (core_1.jsx("div", { className: carabiners_1.joinStr(styles_scss_1.default.switchContainer, className), "data-testid": testId },
        !hideLabel && core_1.jsx("label", { htmlFor: name }, label),
        core_1.jsx(react_select_1.default, Object.assign({ "aria-label": ariaLabel, className: carabiners_1.joinStr(styles_scss_1.default.select, className), defaultValue: defaultValue, value: value, error: !!error, id: name, isDisabled: disabled, isMulti: multiselect, label: label, onBlur: onBlur, onChange: onChange, options: options, placeholder: placeholder, removeSelected: false, styles: selectStyles, theme: selectTheme }, specialProps)),
        core_1.jsx("span", { className: styles_scss_1.default.errorMessage }, error)));
};
// menuIsOpen
Dropdown.defaultProps = {
    error: undefined,
    label: '',
    testId: '',
    ariaLabel: 'Dropdown',
    className: '',
    disabled: false,
    multiselect: false,
    onBlur: null,
    onChange: undefined,
    placeholder: '',
    selectStyles: styles_1.default,
    selectTheme: styles_1.CustomSelectTheme,
    value: undefined,
    defaultValue: undefined,
    hideLabel: false,
};
exports.default = Dropdown;
